import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Button, TextField, Typography } from '@mui/material';
import Title from '../custom/Title';
import { TStepsProps } from '../../Models/common';
import useService from '../../hooks/useService';
import { fetchJobworkInventory } from '../../services/Transactions';
import { createStockTransferOrder } from '../../services/Inventory';
import { InventoryData, TransactionDetail, logisticOptions } from '../../Models/Inventory';
import { useNavigate, useParams } from 'react-router-dom';
import { genId } from '../../utils/helpers';
import { TRANSACTION_STATUS, TRANSACTION_TYPES } from '../../utils/constant';
import StepNavigation from '../custom/StepNavigation';
import DynamicForm, { TField, useDynamicForm } from '../forms/DynamicFormNew';

const InventoryDetailGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(min(300px, 100%), 1fr));
    list-style: none;
    margin: 20px 0;
    padding: 0;
    grid-gap: 10px;
    row-gap: 10px;
    padding: 10px;
`
type TInventoryTransfer = {
    logisticAgencyName: string
    awbNumber?: string
    remarks: string
    otherLogisticAgencyName : string
}
const INVENTORY_TRANSFER_FORM: TField<TInventoryTransfer>[] = [
    {
        fieldName:'logisticAgencyName',
        isVisible:true,
        fieldType: 'select',
        label: 'Logistic Agency Name',
        fullWidth: false,
        options: logisticOptions,
        validation: {
            required:true
        }
    },
    {
        fieldName:'otherLogisticAgencyName',
        isVisible:false,
        fieldType: 'text',
        label: 'Enter Logistic Agency Name',
        fullWidth: false,
        validation: {
            required:false
        }
    },
    {
        fieldName:'awbNumber',
        isVisible:true,
        fieldType: 'text',
        label: 'AWB Number',
        fullWidth: false,
        // validation: {
        //     required:true
        // }
    },
    {
        fieldName:'remarks',
        isVisible:true,
        fieldType: 'text',
        label: 'Remarks',
        fullWidth: false,
        validation: {
            required:true
        }
    },
]

function TransferOrderPvtToPlant(props: TStepsProps) {
    const { path, nextSection, prevSection, nextButtonLable } = props
    const { execute, store: { transactionsStore, notificationStore } } = useService()
    const { jobworkInventory, transactionInfo, capturedSteps, setCapturedSteps, setTransactionInfo, inboundDetails } = transactionsStore
    const { notify } = notificationStore
    const { globalTransactionNumber } = transactionInfo
    // const remarksRef = React.useRef<HTMLInputElement>(null)
    // const awbRef = React.useRef<HTMLInputElement>(null)
    const [forceNavigate, setForceNavigate] = useState(false)
    const [showOtherAgency, setShowOtherAgency] = useState(false)

    const { registerForm, formData ,setField} = useDynamicForm({formConfig: INVENTORY_TRANSFER_FORM})

    useEffect(() => {
      
    if(formData && formData?.logisticAgencyName == "Other")
        setField('otherLogisticAgencyName', {isVisible: true,validation: {required:true }})
    else
        setField('otherLogisticAgencyName', {isVisible: false,validation: {required:false }})
      
    }, [formData])
    

    const navigate = useNavigate()
    const { id } = useParams()

    const goToNextSection = () => {
        if (!capturedSteps.includes('PVC_TO_PLANT'))
            return notify(`Complete PVC To Plant first.`, 'error')

        if (id) navigate(path + '/' + id + '?section=' + nextSection)
        else navigate(path + '?section=' + nextSection)
    }

    const goToPrevSection = () => {
        if (id) navigate(path + '/' + id + '?section=' + prevSection)
        else navigate(path + '?section=' + prevSection)
    }

    const submitHandler = async (data: TInventoryTransfer) => {
        // e.preventDefault()
        // if (!awbRef.current?.value) return notify('AWB Number cannot be emoty', 'error')
        // if (!remarksRef.current?.value) return notify('Remarks cannot be emoty', 'error')

        const { awbNumber, logisticAgencyName, remarks, otherLogisticAgencyName} = data
        console.log(otherLogisticAgencyName,logisticAgencyName ,'otherLogistic_name')
        let logistic_agency_name_formData = ''
        if(logisticAgencyName == "Other")
            logistic_agency_name_formData = `${otherLogisticAgencyName} (Other)`
        else
            logistic_agency_name_formData = logisticAgencyName

        const { error } = await execute(() => createStockTransferOrder({
            inventoryLineItems: [
                {
                    ...jobworkInventory,
                    transactionDetails: {
                        globalTransactionNumber: transactionInfo.globalTransactionNumber!,
                        inboundId: inboundDetails.id,
                        centreId: transactionInfo.pvcCenterId,
                        createdAt: transactionInfo.createdAt as unknown as string,
                        currency: transactionInfo.currency,
                        customerRefNo: transactionInfo.customerId,
                        remarks: transactionInfo.remarks,
                        secondaryTransactionLocation: transactionInfo.secondaryTransactionLocationId,
                        status: transactionInfo.status,
                        transactionType: transactionInfo.transactionType,
                        updatedAt: transactionInfo.updatedAt as unknown as string,
                        weightUOM: transactionInfo.weightUOM
                    } as TransactionDetail,
                    transferredWeight: jobworkInventory.currentWeight,
                    unitWeight: jobworkInventory.currentWeight,
                    remarks: '',
                    fineWeightChange: jobworkInventory.currentFineWeight 
                } as InventoryData],
            remarks: remarks,
            destination_id: '',
            gross_rate: 0,
            invoice_grand_total: 0,
            // mts_delivery_challan_code: 'sample' + genId(),
            // is_mts_transfer: false,
            // is_mts_updated: false,
            // mts_transfer_type: '',
            shipper_id: '',
            status: '',
            total_gold_fine_weight: jobworkInventory.currentFineWeight,
            total_silver_fine_weight: 0,
            acknowledged_at: '',
            acknowledgement_remarks: '',
            created_by: '',
            awb_number: awbNumber,
            logistic_agency_name: logistic_agency_name_formData
        }))

        if (error === null) {
            notify('Metal transferred to plant Successfully')
            setCapturedSteps(prev => {
                return [...prev, 'PVC_TO_PLANT']
            })
            const nextTransactionStatus = transactionInfo.transactionType === TRANSACTION_TYPES.GMS ? TRANSACTION_STATUS.COMPLETED : TRANSACTION_STATUS.CONFIRM_PHYSICAL_ORDER
            setTransactionInfo(prev => ({...prev, status:nextTransactionStatus }))
            if(transactionInfo.transactionType === TRANSACTION_TYPES.JOB_WORK){
                notify('Physical order will be confirmed, once transfer acknowledge by plant')
                navigate("/") 
            }
            setForceNavigate(true)
        }
    }

    useEffect(() => {
        if(transactionInfo.status === TRANSACTION_STATUS.PVC_TO_PLANT_INITIATED) execute(() => fetchJobworkInventory({ globalTransactionNumber: globalTransactionNumber! }))
    }, [])

    useEffect(() => {
        if (forceNavigate) goToNextSection()
    }, [forceNavigate])

    return (
        <>
            <div style={{ borderBottom: '1px solid #d8d8d8' }}>
                <Title style={{ textAlign: 'left', margin: '20px 10px 10px 10px', color: '#7f7d76' }}>Transfer Order Details</Title>
            </div>
            {transactionInfo.status === TRANSACTION_STATUS.PVC_TO_PLANT_INITIATED ?
                <>
                    <InventoryDetailGrid >
                        <InventoryItem label='Metal Type' value={jobworkInventory.metalType} />
                        <InventoryItem label='Metal Weight' value={jobworkInventory.currentWeight + ' grams'} />
                        <InventoryItem label='Metal Fine Weight' value={jobworkInventory.currentFineWeight + ' grams'} />
                        <InventoryItem label='Metal Purity' value={jobworkInventory.purity} />
                    </InventoryDetailGrid>
                    <div style={{ margin: '2px auto' }}>

                        {/* <form onSubmit={submitHandler} style={{ maxWidth: '600px', padding: '10px', display: 'flex', flexDirection: 'column', gap: '20px' }}>
                            <TextField
                                label='AWB Number'
                                fullWidth
                                inputRef={awbRef}
                                size='small'
                            />
                            <TextField
                                multiline
                                label='Remarks'
                                fullWidth
                                inputRef={remarksRef}
                            />
                            <Button variant='contained' type='submit'>Transfer Metal To Plant</Button>
                        </form> */}
                        <DynamicForm {...registerForm()} onSubmit={submitHandler} submitText='Transfer Metal To Plant' />
                    </div>
                </>
                :
                <div style={{ padding: '10px' }}>
                    <p>Metal has already been transfered to the PVC Plant</p>
                </div>}
            <div style={{ padding: '10px' }}>
                <StepNavigation
                    capturedSteps={capturedSteps}
                    currentSection='PVC_TO_PLANT'
                    goToNextSection={goToNextSection}
                    nextButtonLable={nextButtonLable}
                    goToPrevSection={goToPrevSection}
                    prevSection={prevSection}
                />
            </div>
        </>
    )
}

export default TransferOrderPvtToPlant

export const InventoryItem = ({ label, value }: { label: string, value: any }) => {
    return <div style={{ display: 'flex', borderRadius: '4px', overflow: 'hidden', border: '1px solid #e7e7e7' }}>
        <div style={{ width: '50%', background: '#e7e7e7', padding: '10px', }}>
            <Typography variant='body1'>
                {label}
            </Typography>
        </div>
        <div style={{ width: '50%', padding: '10px', textTransform: 'capitalize' }}>{value}</div>
    </div>
}